import TranslateMenus from "@/views/admin/translate/TranslateMenus";

export default {
  path: "translate/menus",
  name: "TranslateMenus",
  component: TranslateMenus,
  props: true,
  meta: {
    requiresAuth: true,
    owner: true
  }
};
